////////LIBRARY/////////
import React, { Fragment, useState, useRef } from 'react'
import styled from 'styled-components'
import { useSelector, shallowEqual } from 'react-redux'
///////COMPONENTS///////
import Skeleton from 'react-loading-skeleton'
/////////ASSETS/////////
import noPicture from '../../../assets/icones/global/no-picture.svg'

//////STYLED//////
const KioskEditImplantationImgWrapper = styled.img`
	max-height: 40px;
	max-width: 40px;
`
const KioskEditImplantationImgWrapperThumb = styled.div`
	position: absolute;
	display: ${(props) => (props.over ? 'grid' : 'none')};
	grid-template-columns: max-content;
	/*grid-auto-rows: 40px;*/
	justify-content: stretch;
	align-items: stretch;
	background-color: ${(props) => props.theme.colors.white};
	box-shadow: 0 0px 6px rgba(0, 0, 0, 0.16);
	padding: 10px 10px;
	top: ${(props) => {
		switch (parseInt(props.indexRow)) {
			case 0:
				return '45px'

			case parseInt(props.dataSize) - 1:
				return '90%'

			default:
				return 'unset'
		}
	}};
	bottom: ${(props) => {
		switch (parseInt(props.indexRow)) {
			case 0:
				return 'unset'

			case parseInt(props.dataSize) - 1:
				return '0%'

			default:
				return 'unset'
		}
	}};
	left: 52%;
	transform: ${(props) => {
		switch (parseInt(props.indexRow)) {
			case 0:
				return 'translateX(50%)'

			case parseInt(props.dataSize) - 1:
				return 'translateX(50%)'

			default:
				return 'translateX(50%) translateY(-75%)'
		}
	}};
	z-index: 5;
	overflow: hidden;
`
const ImgThumb = styled.img`
	max-height: 160px;
	max-width: 80px;
	padding-top: ${(props) => (props.sizeW == 40 ? 40 : (40 - (40 - props.sizeW)) / 2)}px;
	padding-bottom: ${(props) => (props.sizeW == 40 ? 40 : (40 - (40 - props.sizeW)) / 2)}px;
`
//////STYLED//////

const KioskEditImplantationImg = (props) => {
	const { translations } = useSelector(
		(state) => ({
			translations: state.languages.translations,
		}),
		shallowEqual
	)

	const [over, setOver] = useState(false)
	const [sizeW, setSizeW] = useState()
	const [sizeH, setSizeH] = useState()

	///////////////////////////////// HANDLE ///////////////////////////////////////

	const handleMousseOver = (r) => {
		setOver(true)
		setSizeW(r.width)
		setSizeH(r.height)
	}

	const hanleMousseOut = () => {
		setOver(false)
	}

	const refThumb = useRef()
	const refImg = useRef()

	const handleErrImg = (r) => {
		r.src = noPicture
	}

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Fragment>
			{props.column.useCustomSkeleton && props.row.rowTableSkeleton ? (
				<Skeleton width={40} height={50} style={{ lineHeight: '50px' }} />
			) : (
				<KioskEditImplantationImgWrapper
					ref={refImg}
					src={props.row.itemPicture === null ? noPicture : `/${props.row.itemPicture}`}
					onMouseOver={() => handleMousseOver(refImg.current)}
					onMouseOut={() => hanleMousseOut()}
					onError={() => handleErrImg(refImg.current)}
				/>
			)}
			{over && (
				<KioskEditImplantationImgWrapperThumb over={over} indexRow={props.indexRow} dataSize={props.dataSize}>
					<ImgThumb
						src={props.row.itemPicture === null ? noPicture : `/${props.row.itemPicture}`}
						ref={refThumb}
						onError={() => handleErrImg(refThumb.current)}
						sizeW={sizeW}
						sizeH={sizeH}
					/>
				</KioskEditImplantationImgWrapperThumb>
			)}
		</Fragment>
	)
}

KioskEditImplantationImg.propTypes = {}

KioskEditImplantationImg.defaultPropTypes = {}

export default KioskEditImplantationImg
